// extracted by mini-css-extract-plugin
export default {"promoBannerWrap":"MHVDLP0TueGnH948wxn6","parallaxContainer":"BRrzjY6a5U4YgdNrTcDZ","coinWrap":"_rULZ60QB4H890iGSGIQ","mainWrapper":"diV__cEuI1JVxKAl_Dtg","heroImageWrapper":"Kni9YxFmmgVhXBqaV1hy"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"promoBannerWrap\":\"MHVDLP0TueGnH948wxn6\",\"parallaxContainer\":\"BRrzjY6a5U4YgdNrTcDZ\",\"coinWrap\":\"_rULZ60QB4H890iGSGIQ\",\"mainWrapper\":\"diV__cEuI1JVxKAl_Dtg\",\"heroImageWrapper\":\"Kni9YxFmmgVhXBqaV1hy\"}";
        // 1755964983531
        var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  